import * as React from "react";
import * as ReactRouter from "react-router-dom";
import { LocaleProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_US";

import "./sass/main.scss";

import "purecss/build/base-min.css";
import "purecss/build/grids-min.css";

import { Choropleth } from "./modules/core/Chart/Choropleth";
import Feature from "./modules/common/components/Feature";
import DynamicRedirect from "./modules/common/components/DynamicRedirect";
import { HeaderContainer } from "./modules/common";
import { ViewMerchantsContainer } from "./modules/Merchant";
import { ViewReportContainer } from "./modules/Report";
import { ProtectedContainer } from "./modules/User";
import { AnalyticsContainer } from "./modules/Analytics";
import { StoreVisitsContainer } from "./modules/StoreVisits";
import { Authorization } from "./modules/common";
import { AnalyticsValidator } from "./modules/Analytics/components/AnalyticsValidator";
import MaintenanceBanner from "./modules/common/components/MaintenanceBanner";

const { Route, Redirect, Switch } = ReactRouter;

class App extends React.Component<any, any> {
  render() {
    const { permissions } = this.props.user;

    return (
      <LocaleProvider locale={enUS}>
        <ProtectedContainer>
          <div className="app">
            <MaintenanceBanner />
            <HeaderContainer />
            <Switch>
              <Route
                exact
                path="/merchants"
                render={(props: any) => (
                  <Authorization routerProps={props} permissions={permissions}>
                    <ViewMerchantsContainer />
                  </Authorization>
                )}
              />

              <Route
                exact
                path="/merchants/:merchant_id"
                render={(props: any) => (
                  <Authorization routerProps={props} permissions={permissions}>
                    <ViewReportContainer />
                  </Authorization>
                )}
              />

              <Route
                exact
                path="/map"
                render={(props: any) => (
                  <Feature flag="map_viz" redirect="/analytics">
                    <Choropleth country="usa" />
                  </Feature>
                )}
              />

              <Route
                exact
                path="/mapca"
                render={(props: any) => (
                  <Feature flag="map_viz" redirect="/analytics">
                    <Choropleth country="canada" />
                  </Feature>
                )}
              />

              <Route
                exact
                path="/lastrun/:num/:merchant_id/:metric"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/lastweek/:num/:merchant_id/:metric"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/lastrun/:num/:param2"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/lastweek/:num/:param2"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/lastrun/:num"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/lastweek/:num"
                render={(props: any) => <DynamicRedirect routerProps={props} />}
              />

              <Route
                exact
                path="/analytics"
                render={(props: any) => (
                  <Feature flag="analytics_ui" redirect="/merchants">
                    <Authorization
                      routerProps={props}
                      permissions={permissions}
                    >
                      <AnalyticsValidator {...props}>
                        <AnalyticsContainer />
                      </AnalyticsValidator>
                    </Authorization>
                  </Feature>
                )}
              />

              <Route
                exact
                path="/store-visits"
                render={(props: any) => (
                  <Feature flag="store_visits_ui" redirect="/analytics">
                    <Authorization
                      routerProps={props}
                      permissions={permissions}
                    >
                      <StoreVisitsContainer props />
                    </Authorization>
                  </Feature>
                )}
              />
              <Redirect to="/analytics" />
            </Switch>
          </div>
        </ProtectedContainer>
      </LocaleProvider>
    );
  }
}

// TODO: export container
export default App;



// WEBPACK FOOTER //
// ./client/App.tsx